exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".version-update[data-v-c2405414] {\n  background-color: #00e1ba;\n  color: #000000;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  text-align: center;\n  cursor: pointer;\n}\n", ""]);

// exports
